// extracted by mini-css-extract-plugin
export var container = "_av-0";
export var icon = "_av-1";
export var text = "_av-2";